import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import familyFestApi from '@infrastructure/family-fest-api';
export const getAllParkingSlotsAsync = createAsyncThunk('familyFestParkingSlot/getAll', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestApi.getAllParkingSlots(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
